import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import TEXT from "../../../utils/globalText";
// Component
import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import useCategories from "../../../utils/useCategories";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { fieldForceTxnRequestSuccessDetail } from "../../../redux/features/fieldForceTransaction";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import ICONS from "../../../assets/Icons";

const FieldForceRequestCreateSucess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const {
    fieldForceTxnSuccessRequestData,
    fieldForceTxnSuccessRequestLoading,
  } = useSelector((state) => state.fieldForceTransaction);

  const categoryMapper = useCategories();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);
  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, []);
  //   useEffect(() => {
  //     if (
  //       fieldForceTxnSuccessRequestDataError ==
  //       "Request failed with status code 404"
  //     ) {
  //       navigate(`/field_force_transaction_dashboard/create_field_force_transaction/failed`);
  //     }
  //   }, [fieldForceTxnSuccessRequestDataError]);

  useEffect(() => {
    dispatch(fieldForceTxnRequestSuccessDetail(id));
  }, [id]);

  const viewDetailsHandler = () => {
    navigate(
      `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${id}`,
    );
  };

  const beneAccount = () => {
    const beneId =
      fieldForceTxnSuccessRequestData?.request[0]?.field_force_account_id;

    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${beneId}`,
    );
  };

  const createAccountHandler = () => {
    navigate("/field_force_transaction_dashboard/create_field_force_request");
  };

  const dashboardHandler = () => {
    navigate("/field_force_transaction_dashboard");
  };

  // Button

  const buttonRows = [
    [
      {
        btnText: "Create request",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  return (
    <>
      <StatusContainer
        isLoading={fieldForceTxnSuccessRequestLoading}
        status="success"
        hoverOption="white"
        title={"Request created successfully and approval is pending."}
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Request details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    fieldForceTxnSuccessRequestData?.request[
                      GlobalConfiguration.lengthCheckZero
                    ]?.field_force_account_name,
                  leftSubTitle: "Account name",
                  hasRight: true,
                  rightText: true,
                  rightTitleTextColor: "var(--text-primary)",
                  rightTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          fieldForceTxnSuccessRequestData?.request?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.requested_amount
                        }
                      />
                    </>
                  ),
                  rightTextFontWeight: "semibold",
                  rightSubTitle: "Amount",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={beneAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    fieldForceTxnSuccessRequestData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.field_force_account_bank_acc_no,
                  ),
                  leftSubTitle: TEXT?.ACCOUNT_NUMBER,
                  ifsc: fieldForceTxnSuccessRequestData?.request[
                    GlobalConfiguration.lengthCheckZero
                  ]?.field_force_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    fieldForceTxnSuccessRequestData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.category_id?.category_name || "Mobile Bil",
                  leftSubTitle: "Category",
                  icon: categoryMapper(
                    fieldForceTxnSuccessRequestData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.category_id?.category_id,
                  )?.url,
                  iconColor: categoryMapper(
                    fieldForceTxnSuccessRequestData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.category_id?.category_id,
                  )?.colour,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default FieldForceRequestCreateSucess;
